const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

const getLeadFileByIdApi = async (leadId, fileId) => {
  const token = localStorage.getItem('token');
  const response = await fetch(`${API_BASE_URL}/admin/lead/leads/${leadId}/files/${fileId}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const error = new Error('Failed to fetch lead file');
    error.status = response.status;
    throw error;
  }

  return response.json();
};

export default getLeadFileByIdApi;
